"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function delimited(props) {
    var formatted;
    var copy = props.value;
    if (props.value === undefined) {
        formatted = "0";
    }
    else {
        if (props.value > 999999 || props.forceAbbreviation) {
            formatted = abbreviate(props.value);
        }
        else {
            if (props.isPercentage) {
                // UQOS-3000: Tiny percentages between 0 and 0.1 are represented by <0.1
                if (props.value > 0 && props.value < 0.1) {
                    formatted = "<0.1";
                }
                else {
                    if (props.round) {
                        copy = Math.round(copy);
                    }
                    formatted = props.value.toLocaleString();
                }
            }
            else {
                if (props.round) {
                    copy = Math.round(copy);
                }
                formatted = copy.toLocaleString();
            }
        }
    }
    return formatted;
}
exports.delimited = delimited;
function abbreviate(value) {
    // because we can force abbreviation we need to catch 0 coming through
    // as a special case so we don't end up with '0M'
    if (value === 0) {
        return "0";
    }
    var string = value.toString();
    var abbreviated;
    if (string.length === 6) {
        abbreviated = "." + string.charAt(0) + "M";
    }
    else {
        abbreviated = string.charAt(0);
        var hundredThousand = string.charAt(1);
        if (parseInt(hundredThousand) > 0) {
            abbreviated = abbreviated + "." + hundredThousand + "M";
        }
        else {
            abbreviated = abbreviated + "M";
        }
    }
    return abbreviated;
}
